import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import AffairsFilters from '../../components/Affairs/AffairsFilters'
import { getCurrentFunctionName } from '../../performanceModeManager';
import AffairsList from '../../components/Affairs/AffairsList';
import AffairsCounters from '../../components/Affairs/AffairsCounters';
import { setFilteredAndSortedAffairs } from '../../redux/affair/affairActions';
import moment from "moment";
import { formatStatus, getColorFromStatusLabel } from '../../redux/affair/affairStatus';
import AffairStatusIcon from '../../components/Affairs/AffairStatusIcon';
import { formatAmountToString, mobileAndTabletCheck } from '../../utils';

class Affairs extends Component {

    constructor(props) {
        super(props);

        if (!this.props.affairsFilters.displayAsList || mobileAndTabletCheck())//Chargement déjà effectué par le composant table
            this.props.setFilteredAndSortedAffairs(this.props.affairsFilters, this.props.tableState,
                this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);

        this.state = {
            columns: [
                {
                    Header: "Code",
                    width: 120,
                    accessor: "code",
                },
                {
                    Header: "Date de début",
                    width: 150,
                    id: 'date_start',
                    accessor: a => moment(a.date_start).format("DD/MM/YYYY"),
                },
                {
                    Header: "Date de fin",
                    width: 150,
                    id: 'date_end',
                    accessor: a => moment(a.date_end).format("DD/MM/YYYY"),
                },
                {
                    Header: "Désignation",
                    accessor: "name",
                    minWidth: 120,
                    maxWidth: 500
                },
                {
                    Header: "Type",
                    minWidth: 100,
                    maxWidth: 200,
                    accessor: "affair_type",
                },
                {
                    Header: "Statut",
                    id: 'state',
                    accessor: "state",
                    Cell: (cellInfo) => {
                        let a = this.props.affairsFilters.filteredAndSortedAffairs.filter((a) => !a.deleted)[cellInfo.index];

                        if (!a)
                            return null;

                        return (
                            <>
                                <AffairStatusIcon state={a.state} />
                                <span className={"status-icon-color-" + getColorFromStatusLabel(a.state)} >
                                    {formatStatus(a.state)}
                                </span>
                            </>
                        )
                    },
                    minWidth: 100,
                    maxWidth: 200,
                },
                {
                    Header: "Montant",
                    width: 150,
                    id: 'planned_sales_amount',
                    accessor: a => formatAmountToString(a.planned_sales_amount)
                },
                {
                    Header: "Date de signature",
                    width: 150,
                    id: 'date_signed',
                    accessor: a => moment(a.date_signed).format("DD/MM/YYYY"),
                },
            ]
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.setFilteredAndSortedAffairs(this.props.affairsFilters, this.props.tableState,
                this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <AffairsFilters affairsFilters={this.props.affairsFilters} />
                <AffairsCounters columns={this.state.columns} />
                <AffairsList columns={this.state.columns} globalContainer={this.props.globalStore.container} affairsFilters={this.props.affairsFilters}
                    filteredAndSortedAffairs={this.props.affairsFilters.filteredAndSortedAffairs} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        affairsFilters: state.affairs,
        tableState: state.tableState,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedAffairs: (affairsFilters, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedAffairs(affairsFilters, tableState, user, customerSiteId, allSites, nbTotalResults)),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(Affairs);
